import { useRef } from 'react';
import MainSection from '../components/main/main-section';
import TarotSection from '../components/tarot/tarot-section';
import ProductsSection from '../components/products/products-section';
import AboutSection from '../components/about/about-section';
import FooterSection from '../components/footer/footer-section';
import './landing-page.scss'

function LandingPage() {
    const section1Ref = useRef();
    const section2Ref = useRef();
    const section3Ref = useRef();
    const section4Ref = useRef();

    // function scrollTo(section) {
    //     section.current.scrollIntoView({ behavior: "smooth" });
    // }

    return (
        <div className="landing-page">
            <div>
                <div ref={section1Ref} className="container">
                    <MainSection />
                </div>
                <div ref={section2Ref} className="container">
                    <TarotSection />
                </div>
                <div ref={section3Ref} className="container">
                    <ProductsSection />
                </div>
                <div ref={section4Ref} className="container">
                    <AboutSection />
                </div>
                <div className="container">
                    <FooterSection />
                </div>
            </div>
        </div>
    );
}

export default LandingPage;